var map = {
	"./ar.png": 1086,
	"./ch.png": 1087,
	"./de.png": 1088,
	"./en.png": 1089,
	"./es.png": 1090,
	"./fr.png": 1091,
	"./gb.png": 1092,
	"./it.png": 1093,
	"./po.png": 1094,
	"./pt.png": 1095,
	"./ru.png": 1096,
	"./tr.png": 1097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 579;